import { FC } from 'react'
import { AdditionalServicesPaymentSchedule } from 'components/AdditionalServices'
import { UserProtectedRoute } from 'routes'

const AdditionalServicesPaymentSchedulePage: FC = () => {
  return (
    <UserProtectedRoute>
      <AdditionalServicesPaymentSchedule />
    </UserProtectedRoute>
  )
}

export default AdditionalServicesPaymentSchedulePage
